import styled from 'styled-components';

import { ReactComponent as ClockIcon } from '@/assets/icons/clock-icon.svg';
import { ReactComponent as StatusApprovedIcon } from '@/assets/icons/status-approved.svg';
import { ReactComponent as StatusDeclinedIcon } from '@/assets/icons/status-declined.svg';
import { VacationStatus } from '@/utils/enums';

const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledStatusDot = styled.span<{ $status: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  transform: translateY(1px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme, $status }) =>
    $status === VacationStatus.Approved
      ? theme.colors.success
      : $status === VacationStatus.Pending
        ? theme.colors.warning
        : theme.colors.error};
`;

const renderStatusIcon = (status: VacationStatus) => {
  switch (status) {
    case VacationStatus.Approved:
      return <StatusApprovedIcon />;
    case VacationStatus.Declined:
    case VacationStatus.Auto_Declined:
      return <StatusDeclinedIcon />;
    case VacationStatus.Pending:
      return <ClockIcon />;
    default:
      return null;
  }
};

const getStatusLabel = (status: VacationStatus) => {
  switch (status) {
    case 'approved':
      return 'Approved';
    case 'declined':
      return 'Declined';
    case 'auto_declined':
      return 'Auto Declined';
    case 'pending':
      return 'Pending';
    default:
      return '-';
  }
};

interface VacationStatusDotProps {
  status: VacationStatus;
}

const VacationStatusDot = ({ status }: VacationStatusDotProps) => {
  return (
    <Status>
      <StyledStatusDot $status={status}>
        {renderStatusIcon(status)}
      </StyledStatusDot>
      {getStatusLabel(status)}
    </Status>
  );
};

export default VacationStatusDot;
